/**
 * Product Form - Auto Open Drawer on Add to Cart
 * Folosește EVENT DELEGATION pentru a funcționa și după reîncărcarea drawer-ului
 */

class ProductFormHandler {
  constructor() {
    this.cartDrawer = null;
    this.isSubmitting = false;
    
    console.log('[PRODUCT-FORM] Handler initialized with event delegation');
    
    // Event delegation la nivel de document
    this.setupEventDelegation();
  }

  setupEventDelegation() {
    // Ascultă TOATE submit-urile de pe pagină
    document.addEventListener('submit', (e) => {
      // Verifică dacă e un form de add-to-cart cu data-open-drawer
      const form = e.target;
      
      console.log('[PRODUCT-FORM] 📝 Form submitted:', {
        hasForm: !!form,
        hasDataOpenDrawer: form?.hasAttribute('data-open-drawer'),
        action: form?.action,
        isCartAdd: form?.action?.includes('/cart/add')
      });
      
      if (!form || !form.matches('form[data-open-drawer]')) {
        console.log('[PRODUCT-FORM] ⏭️ Skipping - not a drawer form');
        return; // Nu e formularul nostru
      }

      // Verifică dacă form-ul are action="/cart/add"
      if (!form.action || !form.action.includes('/cart/add')) {
        console.log('[PRODUCT-FORM] ⏭️ Skipping - not cart add action');
        return;
      }

      console.log('[PRODUCT-FORM] 🎯 Form submit intercepted (delegation)');
      
      // Oprește submit-ul normal
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Procesează add to cart
      this.handleSubmit(form);
    }, true); // capture=true pentru a prinde submit-ul ÎNAINTE de alți listeners
  }

  handleSubmit(form) {
    // Previne double-submit
    if (this.isSubmitting) {
      console.log('[PRODUCT-FORM] ⚠️ Already submitting, ignoring...');
      return;
    }

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton?.hasAttribute('disabled')) {
      console.log('[PRODUCT-FORM] ⚠️ Button disabled, ignoring...');
      return;
    }

    this.isSubmitting = true;
    this.handleLoadingState(form, true);

    // Trimite request-ul AJAX
    const formData = new FormData(form);
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: formData,
    };

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('[PRODUCT-FORM] Add to cart error:', response);
          this.handleErrorMessage(form, response.description);
          return;
        }

        console.log('[PRODUCT-FORM] ✅ Add to cart success!');
        this.handleSuccess(response);
      })
      .catch((error) => {
        console.error('[PRODUCT-FORM] Fetch error:', error);
        this.handleErrorMessage(form, 'There was an error adding the product to cart.');
      })
      .finally(() => {
        this.isSubmitting = false;
        this.handleLoadingState(form, false);
      });
  }

  handleSuccess(response) {
    // Publică eveniment de cart update
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        cartData: response,
      });
    }

    // Reîncarcă drawer-ul FĂRĂ să-l închidă
    this.reloadDrawerContent().then(() => {
      this.cartDrawer = document.querySelector('cart-drawer');
      
      if (this.cartDrawer) {
        // Verifică dacă drawer-ul e deja deschis
        if (!this.cartDrawer.classList.contains('is-open')) {
          // Doar dacă e închis, deschide-l
          setTimeout(() => {
            this.cartDrawer.open();
          }, 50);
        } else {
          // Dacă e deja deschis, doar trigger update pentru progress bar
          console.log('[PRODUCT-FORM] 📊 Triggering progress bar update...');
          if (typeof this.cartDrawer.updateProgressBarOnOpen === 'function') {
            this.cartDrawer.updateProgressBarOnOpen();
          }
        }
      }
    });
  }

  reloadDrawerContent() {
    console.log('[PRODUCT-FORM] 🔄 Reloading drawer content...');
    
    // Salvează starea: drawer-ul era deschis?
    const wasOpen = this.cartDrawer?.classList.contains('is-open');
    console.log('[PRODUCT-FORM] 💾 Drawer was open:', wasOpen);

    return fetch(`${window.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        console.log('[PRODUCT-FORM] 📦 Sections received:', Object.keys(sections));

        // Actualizează cart-drawer - SMOOTH update fără pâlpâială
        if (sections['cart-drawer']) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = sections['cart-drawer'].trim();
          
          const newCartDrawerContent = tempDiv.querySelector('cart-drawer');
          
          if (newCartDrawerContent) {
            const oldCartDrawer = document.querySelector('cart-drawer');
            
            if (oldCartDrawer) {
              console.log('[PRODUCT-FORM] 🔄 Updating cart-drawer content smoothly...');
              
              // CRITICAL: Actualizează DOAR conținutul interior, nu tot elementul
              // Asta previne "pâlpâiala" drawer-ului
              const newInnerHTML = newCartDrawerContent.innerHTML;
              const newDataset = newCartDrawerContent.dataset;
              
              // Actualizează innerHTML (conținutul)
              oldCartDrawer.innerHTML = newInnerHTML;
              
              // Actualizează dataset-urile (data-cart-total-cents, etc)
              Object.keys(newDataset).forEach(key => {
                oldCartDrawer.dataset[key] = newDataset[key];
              });
              
              // Păstrează clasa is-open dacă era deschis
              if (wasOpen) {
                oldCartDrawer.classList.add('is-open');
              }
              
              console.log('[PRODUCT-FORM] ✅ Cart drawer updated smoothly!');
            }
          }
        }

        // Actualizează cart-icon-bubble
        if (sections['cart-icon-bubble']) {
          const cartIconSection = document.getElementById('shopify-section-cart-icon-bubble');
          if (cartIconSection) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = sections['cart-icon-bubble'];
            const newContent = tempDiv.querySelector('.shopify-section')?.innerHTML || sections['cart-icon-bubble'];
            
            cartIconSection.innerHTML = newContent;
            console.log('[PRODUCT-FORM] ✅ Cart icon updated');
          }
        }

        // Actualizează totalul
        return fetch('/cart.js').then((r) => r.json());
      })
      .then((cart) => {
        console.log('[PRODUCT-FORM] 💰 Cart total:', cart.total_price);
        
        this.cartDrawer = document.querySelector('cart-drawer');
        
        if (this.cartDrawer) {
          this.cartDrawer.dataset.cartTotalCents = String(cart.total_price);
          this.cartDrawer.classList.remove('is-empty');
          
          // Forțează să rămână deschis
          if (wasOpen) {
            this.cartDrawer.classList.add('is-open');
          }
          
          console.log('[PRODUCT-FORM] ✅ Drawer ready!');
        }
      })
      .catch((error) => {
        console.error('[PRODUCT-FORM] ❌ Error reloading drawer:', error);
      });
  }

  handleLoadingState(form, isLoading) {
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    const buttonText = submitButton.querySelector('span');
    const spinner = submitButton.querySelector('.loading__spinner');

    if (isLoading) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.classList.add('loading');
      if (buttonText) buttonText.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      submitButton.removeAttribute('disabled');
      submitButton.classList.remove('loading');
      if (buttonText) buttonText.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  handleErrorMessage(form, message) {
    console.error('[PRODUCT-FORM] Error:', message);

    let errorEl = form.querySelector('.product-form__error-message');
    
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'product-form__error-message';
      errorEl.style.cssText = 'color: #dc2626; font-size: 14px; margin-top: 8px; padding: 8px; background: #fee; border-radius: 4px;';
      form.appendChild(errorEl);
    }

    errorEl.textContent = message;

    setTimeout(() => {
      if (errorEl) errorEl.remove();
    }, 5000);
  }
}

// Inițializează handler-ul când DOM-ul e gata
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductFormHandler();
  });
} else {
  new ProductFormHandler();
}

// BACKWARD COMPATIBILITY: Păstrează custom element-ul pentru cazurile legacy
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        // Nu mai face nimic - totul e gestionat prin event delegation
        console.log('[PRODUCT-FORM] Custom element created (legacy)');
      }
    }
  );
}